module.exports = __webpack_public_path__ + "static/img/b02.48d0fbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/b02.png
// module id = bI+c
// module chunks = 0